export default __webpack_public_path__ + "static/media/-1.dccf55c1.png";